import html from '../legacy/rl.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function ReinforcementLearning() {
  return <LegacyHtmlPage slug="rl" title="Reinforcement Learning" html={html} />;
}
